import React from 'react';
export function HowItWorks() {
  const steps = [{
    num: '1',
    desc: "Descarga el protocolo e identifica los '3 Villanos' en tu despensa actual."
  }, {
    num: '2',
    desc: 'Realiza tus compras usando nuestra lista dirigida de sustitutos latinos saludables.'
  }, {
    num: '3',
    desc: 'Sigue el menú de 7 días y observa cómo tu abdomen se desinflama y tu energía regresa desde la primera mañana.'
  }];
  return <section className="bg-white py-20 md:py-28 relative" data-id="element-40">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-6xl" data-id="element-41">
        <div className="text-center mb-16 md:mb-24" data-id="element-42">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-forest mb-6" data-id="element-43">
            Cómo funciona en 3 simples pasos
          </h2>
          <div className="w-24 h-1 bg-gold mx-auto" data-id="element-44"></div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-start gap-8 md:gap-4 relative" data-id="element-45">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-sage z-0" data-id="element-46"></div>

          {steps.map((step, index) => <div key={index} className="flex-1 flex flex-col items-center text-center relative z-10 w-full" data-id="element-47">
              <div className="w-24 h-24 rounded-full bg-cream border-4 border-gold flex items-center justify-center mb-8 shadow-lg" data-id="element-48">
                <span className="text-4xl font-heading font-bold text-forest" data-id="element-49">
                  {step.num}
                </span>
              </div>

              <div className="bg-cream/50 p-6 rounded-sm border border-sage/50 w-full max-w-sm mx-auto h-full" data-id="element-50">
                <p className="text-lg text-dark/80 font-body leading-relaxed" data-id="element-51">
                  {step.desc}
                </p>
              </div>

              {/* Connecting Line (Mobile) */}
              {index < steps.length - 1 && <div className="md:hidden w-0.5 h-12 bg-sage my-4" data-id="element-52"></div>}
            </div>)}
        </div>
      </div>
    </section>;
}